import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, vModelText as _vModelText, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "page-wrap" }
const _hoisted_2 = {
  key: 0,
  class: "page-filters pf-bar"
}
const _hoisted_3 = ["value"]
const _hoisted_4 = {
  key: 1,
  style: {"height":"15px"}
}
const _hoisted_5 = { class: "announcements" }
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = {
  key: 0,
  style: {"text-align":"right"}
}
const _hoisted_8 = ["onClick"]
const _hoisted_9 = {
  key: 0,
  class: "error-msg-wrap"
}
const _hoisted_10 = { class: "form-wrapper slide-up" }
const _hoisted_11 = { class: "form-close" }
const _hoisted_12 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_forge_page_button = _resolveComponent("forge-page-button")!
  const _component_confirm_delete = _resolveComponent("confirm-delete")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[12] || (_cache[12] = _createElementVNode("div", { class: "page-bar" }, [
      _createElementVNode("div", null, [
        _createElementVNode("div", { class: "page-bar-sub" }, "Team"),
        _createElementVNode("div", { class: "page-bar-main" }, "Announcements")
      ])
    ], -1)),
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.$store.state.routeLoaded ? 'slide-up view' : 'hide')
    }, [
      (_ctx.$store.state.user.isAdmin)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedLocation) = $event)),
              onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.getAnnouncements()))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$store.state.user.locations, (location, i) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: i,
                  value: location
                }, _toDisplayString(location), 9, _hoisted_3))
              }), 128))
            ], 544), [
              [_vModelSelect, _ctx.selectedLocation]
            ]),
            _cache[9] || (_cache[9] = _createElementVNode("span", { class: "pf-spacer" }, null, -1)),
            _createVNode(_component_forge_page_button, {
              kinds: ['announcement'],
              label: "Write with AI",
              onApplied: _cache[2] || (_cache[2] = ($event: any) => (_ctx.getAnnouncements()))
            }),
            (_ctx.$store.state.user.teamHubRole == 'Admin')
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.addAnnouncement())),
                  class: "add-btn"
                }, "Add"))
              : _createCommentVNode("", true)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_4)),
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.announcements, (an, i) => {
          return (_openBlock(), _createElementBlock("div", { key: i }, [
            _createElementVNode("div", null, [
              _createElementVNode("i", null, _toDisplayString(an.DateDisplay), 1)
            ]),
            _createElementVNode("div", {
              innerHTML: an.TextDisplay
            }, null, 8, _hoisted_6),
            _createElementVNode("div", null, [
              _createElementVNode("b", null, "  - " + _toDisplayString(an.CreatedBy), 1)
            ]),
            (_ctx.$store.state.user.teamHubRole == 'Admin')
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createElementVNode("a", {
                    onClick: _withModifiers(($event: any) => (_ctx.deleteAnnouncement(an)), ["prevent"]),
                    style: {"color":"red","text-decoration":"underline"}
                  }, "Delete", 8, _hoisted_8)
                ]))
              : _createCommentVNode("", true)
          ]))
        }), 128))
      ])
    ], 2),
    (_ctx.showAdd)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("button", {
                type: "button",
                class: "form-close-x",
                title: "Close",
                onClick: _cache[4] || (_cache[4] = () => { _ctx.showAdd = false })
              }, "×")
            ]),
            _createElementVNode("div", null, [
              _cache[10] || (_cache[10] = _createElementVNode("h3", null, "Location", -1)),
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.Location) = $event))
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$store.state.user.locations, (location, i) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: i,
                    value: location
                  }, _toDisplayString(location), 9, _hoisted_12))
                }), 128))
              ], 512), [
                [_vModelSelect, _ctx.formData.Location]
              ])
            ]),
            _createElementVNode("div", null, [
              _cache[11] || (_cache[11] = _createElementVNode("h3", null, "Message", -1)),
              _withDirectives(_createElementVNode("textarea", {
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formData.Text) = $event))
              }, null, 512), [
                [_vModelText, _ctx.formData.Text]
              ])
            ]),
            _createElementVNode("input", {
              class: _normalizeClass(_ctx.disableButton ? 'disable-button' : ''),
              type: "submit",
              value: "Submit",
              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.submit()))
            }, null, 2)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.showConfirmDelete)
      ? (_openBlock(), _createBlock(_component_confirm_delete, {
          key: 1,
          onConfirm: _ctx.deleteAnnounementConfirm,
          onCancel: _cache[8] || (_cache[8] = () => { _ctx.showConfirmDelete = false; }),
          msg: "Are you sure you would like to delete this announcement?"
        }, null, 8, ["onConfirm"]))
      : _createCommentVNode("", true)
  ]))
}